export default __webpack_public_path__ + "static/media/contacts.465ab2e5.svg";